export default function init() {
    const tiekarttaNavigationOpen = document.querySelector('.wp-block-sitra-navigation .open-button')
    const tiekarttaNavigationClose = document.querySelector('.wp-block-sitra-navigation .close-button')
    const tiekarttaMobileModal = document.querySelector('.wp-block-sitra-navigation.mobile-modal')

    if (tiekarttaMobileModal && tiekarttaNavigationOpen && tiekarttaNavigationClose) {
      openMenu(tiekarttaNavigationOpen, tiekarttaMobileModal)
      closeMenu(tiekarttaNavigationClose, tiekarttaMobileModal)
    }
}

const closeMenu = (button, modal) => {
  button.addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('body').style.overflow = 'visible'
    modal.classList.remove('open')
  })
}

const openMenu = (button, modal) => {
  button.addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('body').style.overflow = 'hidden'
    modal.classList.add('open')
  })
}
